<template>
  <div :class="computedClassName">
    <div v-if="$slots.leftAddon" class="wrn-addon">
      <slot name="leftAddon" />
    </div>
    <slot name="default">
      <input
        :style="{ color: NebraskaColors.textSecondary }"
        class="text-p-3 input"
        v-bind="$attrs"
        :value="value"
        type="number"
        data-testid="order-quantity"
        @input="$emit('input', Number($event.target.value))"
      />
    </slot>
    <div v-if="$slots.rightAddon" class="wrn-addon">
      <slot name="rightAddon" />
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

@Component({
  inheritAttrs: false
})
export default class OrderInput extends Vue {
  @Prop({ type: Number })
  private value!: number;

  /**
   *  Input size. Possible values:
   *  `xl, sm, lg`
   */
  @Prop({ type: String, default: '' })
  private size!: string;

  private NebraskaColors = NebraskaColors;

  private get computedClassName() {
    const size = this.size;
    const computedClass = ['wrn-input'];

    if (size) {
      computedClass.push(`wrn-input-${size}`);
    }

    return computedClass;
  }
}
</script>

<style lang="less" scoped>
.input {
  background: @background-primary;
}
</style>
